const RoomsTypes = {
  SET_ROOMS_LOADING: 'ROOMS/SET_ROOMS_LOADING',
  SET_ROOMS_FAILURE: 'ROOMS/SET_ROOMS_FAILURE',
  SET_ROOMS_SUCCESS: 'ROOMS/SET_ROOMS_SUCCESS',
};

export default RoomsTypes;